import {
    FETCH_NOTIFICATION_UNREAD_COUNT_SUCCESS,
    FETCH_NOTIFICATION_UNREAD_COUNT_ERROR,
    FETCH_NOTIFICATION_INBOX_SUCCESS,
    FETCH_NOTIFICATION_INBOX_ERROR
} from './actions';
import {notificationsService} from '../service/notifications_service';

/**
 * Fetch unread notification count, dispatch the appropriate action.
 *
 * @returns {function} dispatch function
 */
export function fetchNotificationUnreadCount() {
    return (dispatch) => {
        return notificationsService.getUnreadCount().then((res) => {
            dispatch({type: FETCH_NOTIFICATION_UNREAD_COUNT_SUCCESS, result: res});
        }).catch((err) => {
            dispatch({type: FETCH_NOTIFICATION_UNREAD_COUNT_ERROR, result: err});
        });
    }
}

/**
 * Fetch notification inbox page.
 *
 * @param {number} offset - pagination offset
 * @param {number} limit - page size
 * @returns {function} dispatch function
 */
export function fetchNotificationInbox(offset = 0, limit = 20) {
    return (dispatch) => {
        return notificationsService.getInbox({offset, limit}).then((res) => {
            dispatch({type: FETCH_NOTIFICATION_INBOX_SUCCESS, result: res});
        }).catch((err) => {
            dispatch({type: FETCH_NOTIFICATION_INBOX_ERROR, result: err});
        });
    }
}
